import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CheckboxSingleFormInput from '@src/components/shared/form_elements/CheckboxSingleFormInput.vue';
import { useFieldModel } from '@src/components/shared/form_fields/useFieldModel';
import FieldContainer from '@src/components/patterns/FieldContainer.vue';

interface Props {
	name: string;
	inputId: string;
	modelValue: boolean;
	disabled?: boolean;
	required?: boolean;
	ariaDescribedby?: string;
	isMaxWidthField?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxField',
  props: {
    name: {},
    inputId: {},
    modelValue: { type: Boolean },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    ariaDescribedby: { default: '' },
    isMaxWidthField: { type: Boolean }
  },
  emits: [ 'update:modelValue', 'field-changed' ],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const fieldModel = useFieldModel<boolean>( () => props.modelValue, props.modelValue );

const onFieldChange = ( newValue: boolean ): void => {
	emit( 'update:modelValue', newValue );
	emit( 'field-changed', props.name );
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FieldContainer, {
    "input-id": __props.inputId,
    "is-max-width-field": __props.isMaxWidthField
  }, {
    field: _withCtx(() => [
      _createVNode(CheckboxSingleFormInput, {
        modelValue: _unref(fieldModel),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(fieldModel) ? (fieldModel).value = $event : null)),
          onFieldChange
        ],
        name: __props.name,
        "input-id": __props.inputId,
        disabled: __props.disabled,
        ariaDescribedby: __props.ariaDescribedby
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["modelValue", "name", "input-id", "disabled", "ariaDescribedby"])
    ]),
    _: 3
  }, 8, ["input-id", "is-max-width-field"]))
}
}

})